import { render, staticRenderFns } from "./addOutsidePrice.vue?vue&type=template&id=24e33169&scoped=true"
import script from "./addOutsidePrice.vue?vue&type=script&lang=js"
export * from "./addOutsidePrice.vue?vue&type=script&lang=js"
import style0 from "./addOutsidePrice.vue?vue&type=style&index=0&id=24e33169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e33169",
  null
  
)

export default component.exports